import { ElementRef, Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { driver, Driver, PopoverDOM } from 'driver.js';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TourService {
  private router = inject(Router);
  private tolis = '<strong class="text-primary-500">Tolis</strong>';

  // Subjects para comunicación entre componentes
  private tourCompletedSubject = new Subject<any>();
  public tourCompleted$ = this.tourCompletedSubject.asObservable();

  constructor() {}

  /**
   * Inicia el tour del dashboard
   */
  startDashboardTour(): void {
    const driverObj = driver({
      doneBtnText: 'Finalizar',
      nextBtnText: 'Siguiente',
      prevBtnText: 'Atrás',
      popoverClass: 'driver-popover',
      progressText: '{{current}} de {{total}}',
      disableActiveInteraction: true,
      onDestroyStarted: () => {
        this.tourCompletedSubject.next({ tour: 'dashboard', driverObj });
      },
      steps: [
        {
          element: '.tour-menu-cuentas',
          popover: {
            title: 'Administrar cuentas',
            description: `Aquí puedes administrar tu cuenta, puedes cambiarle el nombre, activar alarmas de saldo bajo.`,
            side: 'right',
            align: 'start',
          },
        },
        {
          element: '.tour-menu-vehiculo',
          popover: {
            title: 'Administrar vehículos',
            description: `Aquí puedes registrar y administrar tus vehículos. Además,  puedes comprar y vincular tu tag ${this.tolis}.`,
            side: 'right',
            align: 'start',
          },
        },
        {
          element: '.tour-menu-formas-pago',
          popover: {
            title: 'Administrar formas de pago',
            description: 'Aquí puedes agregar medios de pago, así como recargar tu cuenta de manera rápida y segura.',
            side: 'right',
            align: 'start',
          },
        },
        {
          element: '.tour-menu-movimientos',
          popover: {
            title: 'Explora todos tus movimientos',
            description: `Revisa tus pasos por peaje, analiza tus estadísticas. <br>
            <strong>¡Todo en un solo lugar!</strong>`,
            side: 'right',
            align: 'start',
          },
        },
        {
          element: '.tour-menu-datos-facturacion',
          popover: {
            title: 'Administrar datos de facturación',
            description:
              'Aquí puedes seleccionar  la información para facturación electrónica de tus pasos por peaje,  ten tus datos al día.',
            side: 'right',
            align: 'start',
          },
        },
        {
          element: '.tour-menu-pqr',
          popover: {
            title: 'Administrar PQR',
            description:
              'Crea y gestiona tus PQR. Envía tus peticiones y sigue el estado de cada solicitud. <br> <strong>¡Estamos para ayudarte!</strong>',
            side: 'right',
            align: 'start',
          },
        },
        {
          element: '.tour-estado-cuenta',
          popover: {
            title: 'Estado de tu cuenta',
            description: `Consulta un resumen general de tu cuenta ${this.tolis}:<br>
            <ul>
              <li>- Revisa tu saldo disponible.</li>
              <li>- Realiza recargas.</li>
              <li>- Verifica el estado actual de tu cuenta.</li>
            </ul>
            <br> <strong>¡Todo en un solo lugar!</strong>`,
            side: 'left',
            align: 'start',
          },
        },
        {
          element: '.tour-ultimos-movimientos',
          popover: {
            title: 'Revisa el historial de tus pasos por peaje',
            description: `Si quieres ver más información, haz clic sobre cualquier movimiento para abrir el detalle completo.`,
            side: 'left',
            align: 'start',
          },
        },
        {
          element: '.tour-profile-menu',
          popover: {
            /* onNextClick: () => {
              const element = document.querySelector('.tour-profile-menu') as HTMLElement;
              if (element) {
                element.click();
                driverObj.moveNext();
              }
            }, */
            title: 'Perfil',
            description: `Aquí puedes ver y gestionar la información de tu cuenta ${this.tolis}. <br>
            <ul>
              <li>- Cambiar tu contraseña.</li>
              <li>- Edita tus datos personales.</li>
              <li>- Cierra sesión de manera segura.</li>
            </ul>`,
            side: 'left',
            align: 'start',
          },
        },
        {
          element: '.tour-notificaciones-cuenta',
          popover: {
            title: 'Notificaciones',
            description: `Aquí puedes ver y gestionar las notificaciones de tu cuenta`,
            side: 'left',
            align: 'start',
          },
        },
        /* {
          element: '.tour-cambiar-contrasena',
          popover: {
            onPrevClick: () => {
              const element = document.querySelector('.tour-profile-menu') as HTMLElement;
              if (element) {
                element.click();
                driverObj.movePrevious();
              }
            },
            title: 'Cambiar contraseña',
            description: 'Aquí puedes cambiar tu contraseña, si deseas cambiar tu contraseña, haz click en el botón.',
          },
        },
        {
          element: '.tour-editar-perfil',
          popover: {
            title: 'Editar perfil',
            description: 'Aquí puedes editar tu perfil, si deseas editar tu perfil, haz click en el botón.',
          },
        },
        {
          element: '.tour-cerrar-sesion',
          popover: {
            onNextClick: () => {
              const element = document.querySelector('.tour-profile-menu') as HTMLElement;
              if (element) {
                element.click();
              }
              driverObj.moveNext();
            },
            title: 'Cerrar sesión',
            description: 'Aquí puedes cerrar sesión, si deseas cerrar sesión, haz click en el botón.',
          },
        }, */
        {
          element: '.tour-repeat-dashboard',
          popover: {
            /* onPrevClick: () => {
              const element = document.querySelector('.tour-profile-menu') as HTMLElement;
              if (element) {
                element.click();
                driverObj.movePrevious();
              }
            }, */
            title: 'Guía interactiva',
            description: 'Toca el icono de la brújula para realizar el recorrido todas las veces que quieras.',
            side: 'left',
            align: 'start',
          },
        },
      ],
    });
    driverObj.drive();
  }

  /**
   * Inicia el tour de vehículos
   */
  startVehiculoTour(): void {
    const driverObj = driver({
      doneBtnText: 'Finalizar',
      nextBtnText: 'Siguiente',
      prevBtnText: 'Atrás',
      showProgress: false,
      disableActiveInteraction: true,
      onDestroyStarted: () => {
        this.tourCompletedSubject.next({ tour: 'vehiculo', driverObj });
      },
      steps: [
        {
          element: '.tour-listado-vehiculos',
          popover: {
            title: 'Gestiona tus vehículos',
            description: `Desde aquí puedes: <br>Visualizar el listado del total de vehículos que tienes registrado en tu cuenta Tolis`,
            side: 'left',
            align: 'start',
          },
        },
        {
          element: '.tour-adquirir-tag',
          popover: {
            onNextClick: () => {
              const element = document.querySelector('.tour-adquirir-tag') as HTMLElement;
              if (element) {
                element.click();
                this.waitForElementDriver(driverObj, '.tour-modal-adquirir-tag');
              }
            },
            title: 'Adquiere tu tag',
            description: `Para comenzar a usar TOLIS, necesitas adquirir tu Tag. Si aún no lo tienes, puedes adquirirlo aquí fácilmente.`,
            side: 'left',
            align: 'start',
          },
        },
        {
          element: '.tour-modal-adquirir-tag',
          popover: {
            onPrevClick: () => {
              const element = document.querySelector('.p-dialog-header-close') as HTMLElement;
              if (element) {
                element.click();
                driverObj.movePrevious();
              }
            },
            onNextClick: () => {
              const element = document.querySelector('.p-dialog-header-close') as any;
              if (element) {
                element.click();
                driverObj.moveNext();
              }
            },
            title: 'Realiza la compra de tu tag',
            description: `Ingresa tu dirección para que podamos enviarte el tag. <br>
            <strong>¡Queremos que lo tengas lo antes posible para que comiences a disfrutar del viaje!</strong>`,
            side: 'left',
            align: 'start',
          },
        },
        {
          element: '.tour-registrar-vehiculo',
          popover: {
            onPrevClick: () => {
              const element = document.querySelector('.tour-adquirir-tag') as HTMLElement;
              if (element) {
                element.click();
                this.waitForElementDriver(driverObj, '.tour-adquirir-tag', false);
              }
            },
            onNextClick: () => {
              const element = document.querySelector('.tour-registrar-vehiculo') as HTMLElement;
              if (element) {
                element.click();
                this.waitForElementDriver(driverObj, '.tour-registrar-vehiculo');
              }
            },
            title: 'Registra tu vehículo',
            description: 'Registra tu vehículo y empieza a disfrutar de los beneficios de Tolis.',
          },
        },
        {
          element: '.tour-modal-registrar-vehiculo',
          popover: {
            onPrevClick: () => {
              const element = document.querySelector('.p-dialog-header-close') as any;
              if (element) {
                element.click();
                driverObj.movePrevious();
              }
            },
            onNextClick: () => {
              const element = document.querySelector('.p-dialog-header-close') as any;
              if (element) {
                element.click();
              }
              driverObj.moveNext();
            },
            title: 'Información del vehículo',
            description: 'Ingresa los datos de tu vehículo y registra tu vehículo.',
          },
        },
        {
          popover: {
            onPrevClick: () => {
              const element = document.querySelector('.tour-registrar-vehiculo') as HTMLElement;
              if (element) {
                element.click();
                this.waitForElementDriver(driverObj, '.tour-modal-registrar-vehiculo', false);
              }
            },
            onPopoverRender: function (popover: PopoverDOM) {
              const element = document.querySelector('.driver-popover') as HTMLElement;
              if (element) {
                element.style.minWidth = '900px';
                element.style.minHeight = '500px';
              }
            },
            title: 'Administra tu tag',
            description: `Al momento de administrar tu tag puedes: Asociar un nuevo tag,  Desactivar un tag, Renovar un tag, Eliminar vehículo.<br><br>
            <img src="assets/images/tour-vehiculo.gif" alt="Tag Tolis" class="w-full rounded-lg">
            <br>
            Luego, instálalo en el parabrisas de tu vehículo siguiendo nuestra <a class="text-primary-500 underline" href="https://tolis.com.co/como-instalar-el-tag" target="_blank">Guía instalación Tag - Tolis</a>
            `,
            side: 'over',
            align: 'center',
          },
        },
        /*  {
          element: '.tour-select-vehiculo',
          popover: {
            title: 'Administra tu tag',
            description: `Desde aquí puedes asociar, renovar o inactivar tu tag de forma rápida y sencilla. <br><br>
            <strong>¿Vas a vincular un nuevo tag?</strong> <br>
            Escanea el código QR del dispositivo o ingresa el TAG ID manualmente. <br>
            Luego, instálalo en el parabrisas de tu vehículo siguiendo nuestra <a class="text-primary-500 underline" href="https://tolis.com.co/como-instalar-el-tag" target="_blank">Guía instalación Tag - Tolis</a>`,
            side: 'left',
            align: 'start',
          },
        }, */
      ],
    });
    driverObj.drive();
  }

  startFormasPagoTour(): void {
    const initialPaymentMethod =
      document.querySelector<HTMLInputElement>('input[name="paymentMethod"]:checked')?.value ?? 'prepaid';
    const initialRechargeType =
      document.querySelector<HTMLInputElement>('input[name="rechargeType"]:checked')?.value ??
      document.querySelector<HTMLElement>('.tolis-page')?.dataset['rechargeType'] ??
      'oneTime';
    const clickOption = (selector: string) => document.querySelector<HTMLInputElement>(selector)?.click();
    const driverObj = driver({
      doneBtnText: 'Finalizar',
      nextBtnText: 'Siguiente',
      prevBtnText: 'Atrás',
      showProgress: false,
      disableActiveInteraction: true,
      onDestroyStarted: () => {
        clickOption('.tour-formas-pago-metodo [value="prepaid"]');
        setTimeout(() => {
          clickOption(`.tour-formas-pago-recarga-automatica [value="${initialRechargeType}"]`);
          clickOption(`.tour-formas-pago-metodo [value="${initialPaymentMethod}"]`);
        });
        this.tourCompletedSubject.next({ tour: 'formas-pago', driverObj });
      },
      steps: [
        {
          element: '.tour-formas-pago-metodo',
          popover: {
            title: 'Selecciona la forma de pago',
            description: 'Puedes recargar saldo para tus peajes o pagar cada paso directamente con tu tarjeta.',
          },
        },
        {
          element: '.tour-formas-pago-recarga',
          popover: {
            title: 'Recarga, conduce y vive',
            description: 'Agrega saldo a tu cuenta para cubrir peajes y otros servicios de TOLIS.',
            onNextClick: () => {
              clickOption('.tour-formas-pago-metodo [value="prepaid"]');
              this.waitForElementDriver(driverObj, '.tour-formas-pago-tipo-recarga');
            },
          },
        },
        {
          element: '.tour-formas-pago-tipo-recarga',
          popover: {
            title: 'Elige el tipo de recarga',
            description: 'Puedes hacer una recarga cuando la necesites o dejar que TOLIS recargue por ti.',
            onNextClick: () => {
              clickOption('.tour-formas-pago-recarga-normal [value="oneTime"]');
              this.waitForElementDriver(driverObj, '.tour-formas-pago-recarga-normal');
            },
          },
        },
        {
          element: '.tour-formas-pago-recarga-normal',
          popover: {
            title: 'Recarga normal',
            description: 'Realiza una recarga manual cuando quieras agregar saldo a tu cuenta.',
            onNextClick: () => {
              clickOption('.tour-formas-pago-recarga-automatica [value="auto"]');
              this.waitForElementDriver(driverObj, '.tour-formas-pago-recarga-automatica');
            },
          },
        },
        {
          element: '.tour-formas-pago-recarga-automatica',
          popover: {
            title: 'Recarga automática',
            description: 'TOLIS recarga tu saldo cuando llega al nivel de reserva que configures.',
            onPrevClick: () => {
              clickOption('.tour-formas-pago-recarga-normal [value="oneTime"]');
              this.waitForElementDriver(driverObj, '.tour-formas-pago-recarga-normal', false);
            },
            onNextClick: () => {
              clickOption('.tour-formas-pago-recarga-automatica [value="auto"]');
              this.waitForElementDriver(driverObj, '.tour-formas-pago-configuracion-automatica');
            },
          },
        },
        {
          element: '.tour-formas-pago-configuracion-automatica',
          popover: {
            title: 'Configuración automática de la recarga',
            description: 'Define el saldo que quieres mantener y el nivel de reserva que activará la recarga.',
            onPrevClick: () => {
              clickOption('.tour-formas-pago-metodo [value="prepaid"]');
              setTimeout(() => {
                clickOption('.tour-formas-pago-recarga-automatica [value="auto"]');
                this.waitForElementDriver(driverObj, '.tour-formas-pago-configuracion-automatica', false);
              });
            },
            onNextClick: () => {
              clickOption('.tour-formas-pago-metodo [value="payPerUse"]');
              this.waitForElementDriver(driverObj, '.tour-formas-pago-pasaypaga');
            },
          },
        },
        {
          element: '.tour-formas-pago-pasaypaga',
          popover: {
            title: 'Pasa y Tolis',
            description: 'También puedes pagar cada peaje directamente con tu tarjeta débito o crédito.',
            onNextClick: () => {
              clickOption('.tour-formas-pago-metodo [value="payPerUse"]');
              this.waitForElementDriver(driverObj, '.tour-formas-pago-confirma-tarjeta');
            },
          },
        },
        {
          element: '.tour-formas-pago-confirma-tarjeta',
          popover: {
            title: 'Confirma tu tarjeta',
            description: 'Vincula una tarjeta para que el cobro de cada peaje se realice automáticamente.',
          },
        },
      ],
    });
    driverObj.drive();
  }

  /**
   * Inicia el tour de movimientos
   */
  startMovimientosTour(): void {
    const driverObj = driver({
      doneBtnText: 'Finalizar',
      nextBtnText: 'Siguiente',
      prevBtnText: 'Atrás',
      showProgress: false,
      disableActiveInteraction: true,
      onDestroyStarted: () => {
        this.tourCompletedSubject.next({ tour: 'movimientos', driverObj });
      },
      steps: [
        {
          element: '.tour-reporte-extracto',
          popover: {
            title: 'Reporte extracto',
            description: 'Aquí puedes generar un reporte de extracto.',
          },
        },
        {
          element: '.tour-reporte-movimientos',
          popover: {
            title: 'Reporte de movimientos',
            description: 'Aquí puedes generar un reporte de tus movimientos.',
          },
        },
        {
          element: '.tour-listado-movimientos',
          popover: {
            title: 'Gestiona tus movimientos',
            description: `Desde esta sección puedes ver cada pago que realizaste con tu cuenta ${this.tolis}. <br> Para conocer los detalles de un paso específico, solo tienes que hacer clic en él.`,
            side: 'top',
            align: 'start',
          },
        },
        {
          element: '.tour-detalle-movimientos',
          popover: {
            onNextClick: () => {
              const xpath =
                '/html/body/app-root/div/app-layout/div/div/div/app-movimientos/div/app-listado-movimientos/div/div[1]/div[2]/p-tabview/div/div[1]/div/ul/li[1]/a';

              if (this.clickElementByXpath(xpath)) {
                driverObj.moveNext();
              }
            },
            title: 'Información clave de tus movimiento',
            description: `Aquí puedes ver cuánto saldo tienes y qué día fue el de mayor consumo en tu cuenta ${this.tolis}.`,
            side: 'top',
            align: 'start',
          },
        },
        /* {
          element: '.tour-balance-movimientos',
          popover: {
            title: 'Balance de movimientos',
            description:
              'Aquí puedes ver el balance de tus movimientos, si deseas ver el balance de tus movimientos, haz click en el balance.',
            side: 'top',
            align: 'start',
          },
        },
        {
          element: '.tour-dia-mayor-consumo',
          popover: {
            onNextClick: () => {
              const xpath =
                '/html/body/app-root/div/app-layout/div/div/div/app-movimientos/div/app-listado-movimientos/div/div[1]/div[2]/p-tabview/div/div[1]/div/ul/li[1]/a';

              if (this.clickElementByXpath(xpath)) {
                driverObj.moveNext();
              }
            },
            title: 'Día de mayor consumo',
            description:
              'Aquí puedes ver el día de mayor consumo, si deseas ver el día de mayor consumo, haz click en el día de mayor consumo.',
            side: 'top',
            align: 'start',
          },
        }, */
        {
          element: '.tour-diagramas-movimientos',
          popover: {
            onNextClick: () => {
              // Usar xpath específico para hacer clic en el segundo tab
              const xpath =
                '/html/body/app-root/div/app-layout/div/div/div/app-movimientos/div/app-listado-movimientos/div/div[1]/div[2]/p-tabview/div/div[1]/div/ul/li[2]/a';

              if (this.clickElementByXpath(xpath)) {
                driverObj.moveNext();
              }
            },
            title: 'Diagramas de movimientos',
            description: `Visualiza en gráficos cuántos pasos ha realizado cada uno de tus vehículos. <br>
              Compara su actividad fácilmente y lleva el control de tu flota o tus autos personales.`,
            side: 'top',
            align: 'start',
          },
        },
        {
          element: '.tour-tab-diagramas-movimientos',
          popover: {
            onPrevClick: () => {
              const xpath =
                '/html/body/app-root/div/app-layout/div/div/div/app-movimientos/div/app-listado-movimientos/div/div[1]/div[2]/p-tabview/div/div[1]/div/ul/li[1]/a';

              if (this.clickElementByXpath(xpath)) {
                driverObj.movePrevious();
              }
            },
            title: 'Diagramas de pasos por vehículos',
            description:
              'Aquí puedes ver los diagramas de pasos por vehículos, si deseas ver los diagramas de pasos por vehículos, haz click en el diagrama.',
          },
        },
      ],
    });
    driverObj.drive();
  }

  startDatosFacturacionTour(): void {
    const driverObj = driver({
      doneBtnText: 'Finalizar',
      nextBtnText: 'Siguiente',
      prevBtnText: 'Atrás',
      showProgress: false,
      disableActiveInteraction: true,
      onDestroyStarted: () => {
        this.tourCompletedSubject.next({ tour: 'datos-facturacion', driverObj });
      },
      steps: [
        {
          element: '.tour-datos-facturacion',
          popover: {
            title: 'Datos de facturación',
            description:
              'Aquí puedes modificar la información usada para generar tus facturas electrónicas de peaje. Mantén tus datos siempre actualizados para una facturación sin errores.',
            side: 'left',
            align: 'start',
          },
        },
        {
          element: '.tour-datos-facturacion-info',
          popover: {
            title: 'Información del receptor',
            description:
              'Consulta los datos actuales del receptor de facturación. <br> Esta información se actualiza automáticamente cuando editas los datos de facturación.',
            side: 'left',
            align: 'start',
          },
        },
        {
          element: '.tour-datos-facturacion-agregar',
          popover: {
            onNextClick: () => {
              const element = document.querySelector('.tour-datos-facturacion-agregar') as HTMLElement;
              if (element) {
                element.click();
                this.waitForElementDriver(driverObj, '.tour-registro-receptor-facturacion-modal');
              }
            },
            title: 'Agregar receptores',
            description:
              'Podras agregar receptores de facturación, para que puedan realizar pagos en tu cuenta. ten en cuenta que tienes un limite de registros de receptores de facturación.',
            side: 'left',
            align: 'start',
          },
        },
        {
          element: '.tour-registro-receptor-facturacion-modal',
          popover: {
            onPrevClick: () => {
              const element = document.querySelector('.p-dialog-header-close') as HTMLElement;
              if (element) {
                element.click();
                driverObj.movePrevious();
              }
            },
            onNextClick: () => {
              const element = document.querySelector('.p-dialog-header-close') as HTMLElement;
              if (element) {
                element.click();
                driverObj.moveNext();
              }
            },
            title: 'Registro de receptor de facturación',
            description:
              'Registra los datos de la persona natural o jurídica que deseas asignar como receptor de facturación. <br> Esto te permitirá facturar de forma personalizada y organizada.',
            side: 'right',
            align: 'end',
          },
        },
        {
          element: '.tour-listado-receptores-registrados-table',
          popover: {
            onPrevClick: () => {
              const element = document.querySelector('.tour-datos-facturacion-agregar') as HTMLElement;
              if (element) {
                element.click();
                this.waitForElementDriver(driverObj, '.tour-registro-receptor-facturacion-modal', false);
              }
            },
            title: 'Listado de receptores registrados',
            description:
              'Consulta el listado completo de receptores que has agregado. <br> Desde aquí puedes gestionarlos fácilmente.',
            side: 'left',
            align: 'start',
          },
        },
        {
          element: '.tour-listado-receptores-registrados-table-actions',
          popover: {
            title: 'Acciones de los receptores registrados',
            description:
              'Visualiza los detalles de cada receptor, edítalos o elimínalos cuando lo necesites. <br> ¡Tú tienes el control de la información!',
            side: 'left',
            align: 'start',
          },
        },
      ],
    });
    driverObj.drive();
  }

  startPqrTour(): void {
    driver({
      doneBtnText: 'Finalizar',
      nextBtnText: 'Siguiente',
      prevBtnText: 'Atrás',
      steps: [
        {
          element: '.tour-listado-pqr',
          popover: {
            title: 'Gestiona tus PQR',
            description:
              'Aquí puedes gestionar tus PQR, ver el detalle de cada PQR, si deseas ver el detalle de cada PQR, haz click en el detalle.',
            side: 'left',
            align: 'start',
          },
        },
      ],
    }).drive();
  }

  /**
   * Inicia el tour automático cuando se carga la página principal
   */
  startAutoTourOnDashboard(): void {
    if (this.router.url === '/') {
      setTimeout(() => {
        this.waitForElementAndStartDashboard();
      }, 500);
    }
  }

  /**
   * Inicia el tour de vehículos cuando se navega a esa página
   */
  startAutoTourOnVehiculos(): void {
    setTimeout(() => {
      this.waitForElementAndStartVehiculos();
    }, 500);
  }

  /**
   * Inicia el tour de movimientos cuando se navega a esa página
   */
  startAutoTourOnMovimientos(): void {
    setTimeout(() => {
      this.waitForElementAndStartMovimientosTour();
    }, 500);
  }

  /**
   * Inicia el tour de gestio cuentas cuando se navega a esa página
   */
  startGestionCuentaTour(): void {
    const driverObj = driver({
      doneBtnText: 'Finalizar',
      nextBtnText: 'Siguiente',
      prevBtnText: 'Atrás',
      popoverClass: 'driver-popover',
      progressText: '{{current}} de {{total}}',
      disableActiveInteraction: true,
      onDestroyStarted: () => {
        this.tourCompletedSubject.next({ tour: 'gestion-cuentas', driverObj });
      },
      steps: [
        {
          element: '.tour-gestion-cuentas',
          popover: {
            title: 'Gestionar cuenta',
            description: `Aquí puedes gestionar tu cuenta: asignarle un nombre, actualizar los datos del receptor de facturación y activar alarmas de saldo bajo. `,
            side: 'left',
            align: 'start',
          },
        },
        {
          element: '.tour-gestion-cuentas-datos',
          popover: {
            title: 'Datos de la cuenta',
            description: `Aquí puedes ver los datos de tu cuenta, el saldo disponible y la cantidad de vehículos vinculados.`,
            side: 'left',
            align: 'start',
          },
        },
        {
          element: '.tour-gestion-cuentas-nombre-cuenta',
          popover: {
            title: 'Nombre de la cuenta',
            description: `Aquí puedes ver y editar el nombre de tu cuenta, consultar la forma de pago seleccionada y visualizar o actualizar los datos del receptor de facturación.`,
            side: 'left',
            align: 'start',
          },
        },
        {
          element: '.tour-gestion-cuentas-receptor-facturacion',
          popover: {
            title: 'Receptor de facturación',
            description: `Aquí puedes ver y cambiar los datos de receptor de facturacion.`,
            side: 'left',
            align: 'start',
          },
        },
        {
          element: '.tour-gestion-cuentas-alarma',
          popover: {
            title: 'Alarma saldo bajo',
            description: `Consulta y actualiza el saldo a partir del cual deseas recibir notificaciones cuando tu saldo se esté agotando.`,
            side: 'left',
            align: 'start',
          },
        },
      ],
    });
    driverObj.drive();
  }

    /**
   * Inicia el tour de gestio cuentas cuando se navega a esa página
   */
  startGestionCuentaTourMobile(): void {
    const driverObj = driver({
      doneBtnText: 'Finalizar',
      nextBtnText: 'Siguiente',
      prevBtnText: 'Atrás',
      popoverClass: 'driver-popover',
      progressText: '{{current}} de {{total}}',
      disableActiveInteraction: true,
      onDestroyStarted: () => {
        this.tourCompletedSubject.next({ tour: 'gestion-cuentas', driverObj });
      },
      steps: [
        {
          element: '.tour-gestion-cuentas-mobile',
          popover: {
            onNextClick: () => {const header = document.querySelector('#datos-cuenta .p-accordion-header-link') as HTMLElement;
              if (header) {
                header.click();
                setTimeout(() => driverObj.moveNext(), 300);
              } else {
                driverObj.moveNext();
              }
            },
            title: 'Gestionar cuenta',
            description: `Aquí puedes gestionar tu cuenta: asignarle un nombre, actualizar los datos del receptor de facturación y activar alarmas de saldo bajo.`,
            side: 'left',
            align: 'start',
          },
        },

        {
          element: '#datos-cuenta_content > div > section > div',
          popover: {
            onNextClick: () => {const header = document.querySelector('#datos-facturacion .p-accordion-header-link') as HTMLElement;
              if (header) {
                header.click();
                setTimeout(() => driverObj.moveNext(), 300);
              } else {
                driverObj.moveNext();
              }
            },
            title: 'Nombre de la cuenta',
            description: `Aquí puedes ver y editar el nombre de tu cuenta, ademas ver la forma de pago seleccionada`,
            side: 'left',
            align: 'start',
          },
        },
        {
          element: '#datos-facturacion_content > div > section > div',
          popover: {
            onPrevClick: () => {
              const header = document.querySelector('#datos-cuenta .p-accordion-header-link') as HTMLElement;

              if (header) {
                header.click();
                setTimeout(() => driverObj.movePrevious(), 300);
              } else {
                driverObj.movePrevious();
              }
            },
            onNextClick: () => {const header = document.querySelector('#datos-alarma .p-accordion-header-link') as HTMLElement;
              if (header) {
                header.click();
                setTimeout(() => driverObj.moveNext(), 300);
              } else {
                driverObj.moveNext();
              }
            },
            title: 'Receptor de facturación',
            description: `Aquí puedes ver y cambiar los datos del receptor de facturación.`,
            side: 'left',
            align: 'start',
          },
        },
        {
          element: '#datos-alarma_content > div > section > div',
          popover: {
            onPrevClick: () => {
              const header = document.querySelector('#datos-facturacion .p-accordion-header-link') as HTMLElement;

              if (header) {
                header.click();
                setTimeout(() => driverObj.movePrevious(), 300);
              } else {
                driverObj.movePrevious();
              }
            },
            title: 'Alarma saldo bajo',
            description: `Consulta y actualiza el saldo a partir del cual deseas recibir notificaciones cuando tu saldo se esté agotando.`,
            side: 'left',
            align: 'start',
          },
        },
      ],
    });
    driverObj.drive();
  }

  // Métodos privados auxiliares

  /**
   * Hacer clic en un elemento usando xpath
   */
  private clickElementByXpath(xpath: string): boolean {
    const element = document.evaluate(xpath, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null)
      .singleNodeValue as HTMLElement;

    if (element) {
      element.click();
      return true;
    } else {
      console.error('Elemento no encontrado con xpath:', xpath);
      return false;
    }
  }

  /**
   * Hacer clic en un elemento con reintentos
   */
  private clickElementWithRetry(xpath: string, maxRetries: number = 5, delay: number = 200): void {
    let attempts = 0;

    const tryClick = () => {
      if (this.clickElementByXpath(xpath)) {
        return;
      } else if (attempts < maxRetries) {
        attempts++;
        setTimeout(tryClick, delay);
      } else {
        console.error('Elemento no encontrado después de', maxRetries, 'intentos');
      }
    };

    tryClick();
  }

  private waitForElementDriver(driverObj: Driver, querySelector: string, next: boolean = true): void {
    const checkElement = () => {
      const element = document.querySelector(querySelector);
      if (element) {
        if (next) {
          driverObj.moveNext();
        } else {
          driverObj.movePrevious();
        }
      } else {
        setTimeout(checkElement, 100);
      }
    };
    setTimeout(checkElement, 200);
  }

  private waitForElementAndStartVehiculos(): void {
    const checkElement = () => {
      const element = document.querySelector('.tour-listado-vehiculos');
      if (element) {
        this.startVehiculoTour();
      } else {
        setTimeout(checkElement, 100);
      }
    };
    setTimeout(checkElement, 200);
  }

  private waitForElementAndStartDashboard(): void {
    const checkElement = () => {
      const element = document.querySelector('.tour-ultimos-movimientos');
      if (element) {
        // Aquí podrías emitir un evento o mostrar un modal de confirmación
        // Por ahora, inicia el tour directamente
        this.startDashboardTour();
      } else {
        setTimeout(checkElement, 100);
      }
    };
    setTimeout(checkElement, 200);
  }

  private waitForElementAndStartMovimientosTour(): void {
    const checkElement = () => {
      const element = document.querySelector('.tour-listado-movimientos');
      if (element) {
        this.startMovimientosTour();
      } else {
        setTimeout(checkElement, 100);
      }
    };
    setTimeout(checkElement, 200);
  }

  closeTour(): void {
    const driverObj = driver({
      doneBtnText: 'Finalizar',
      nextBtnText: 'Siguiente',
      prevBtnText: 'Atrás',
    });
    driverObj.destroy();
  }
}
